import { Button, Table, TableCell, TablePager, TableRow } from '@fukuri-admins/ui/common';
import clsx from 'clsx';
import { ROUTES } from '~/utils/routes';
import styles from './styles.module.scss';

type Props = {
  conductedStressAssessments: {
    id: number;
    implementationDate: string;
    deadline: string;
    target: string;
    completed: string;
    notAnswered: string;
    highStress: string;
    status: '実施中' | '完了';
  }[];
  onRowClick: (id: number) => void;
  pagerProps: React.ComponentProps<typeof TablePager>;
  showCreateButton: boolean;
};

export const ConductedStressAssessmentList: React.FC<Props> = ({
  conductedStressAssessments,
  onRowClick,
  pagerProps,
  showCreateButton,
}) => {
  const renderStatusBadge = (value: string) => {
    return (
      <span
        className={clsx(styles.statusBadge, {
          [styles.inProgress]: value === '実施中',
          [styles.completed]: value === '完了',
        })}
      >
        {value}
      </span>
    );
  };

  return (
    <div className={styles.container}>
      <div className={styles.container_Header}>
        <div>
          <p className={styles.title}>実施したストレスチェック</p>
        </div>
        {showCreateButton && (
          <div>
            <Button as='a' href={ROUTES.STRESS_ASSESSMENTS.NEW}>
              ストレスチェックを実施
            </Button>
          </div>
        )}
      </div>

      <div className={styles.table}>
        <div className={styles.tableWrapper}>
          <Table
            scrollable
            fixedHeader
            maxHeight='min(720px, 90vh)'
            headers={[
              { label: '実施日' },
              { label: '回答期限' },
              { label: '対象者（全体）' },
              { label: '完了' },
              { label: '未回答' },
              { label: '高ストレス者' },
              { label: '実施状況' },
            ]}
          >
            {conductedStressAssessments.map(row => (
              <TableRow key={row.id} onClick={() => onRowClick(row.id)}>
                <TableCell>{row.implementationDate}</TableCell>
                <TableCell>{row.deadline}</TableCell>
                <TableCell>{row.target}</TableCell>
                <TableCell>{row.completed}</TableCell>
                <TableCell>{row.notAnswered}</TableCell>
                <TableCell>{row.highStress}</TableCell>
                <TableCell>{renderStatusBadge(row.status)}</TableCell>
              </TableRow>
            ))}
          </Table>
        </div>
        <TablePager {...pagerProps} />
      </div>
    </div>
  );
};
